// extracted by mini-css-extract-plugin
var _1 = "iv8kY";
var _2 = "C6VXW";
var _3 = "F1bFu";
var _4 = "dJBDR";
var _5 = "R3XaB";
var _6 = "FNcxG";
var _7 = "YITQA";
export { _1 as "big-button", _2 as "bottom-branding", _3 as "bottom-branding--mobile", _4 as "error-box", _5 as "pdf-holder", _6 as "right-branding", _7 as "sticky-branding" }
